export const desktopStepsAnim = (
  progress: number,
  {
    imgRef,
    bgRef,
    notificationImgRef,
    contentRef,
    deviceRef,
  }: {
    imgRef: React.MutableRefObject<HTMLDivElement | null>;
    bgRef: React.MutableRefObject<HTMLDivElement | null>;
    notificationImgRef: React.MutableRefObject<HTMLDivElement | null>;
    contentRef: React.MutableRefObject<HTMLDivElement | null>;
    deviceRef: React.MutableRefObject<HTMLDivElement | null>;
  },
) => {
  if (
    !imgRef.current ||
    !bgRef.current ||
    !notificationImgRef.current ||
    !contentRef.current ||
    !deviceRef.current
  ) {
    return;
  }
  if (progress < 0.2) {
    deviceRef.current.style.opacity = '1';
    notificationImgRef.current.style.opacity = `0`;
    imgRef.current.style.opacity = `0`;
    bgRef.current.style.opacity = `1`;
    contentRef.current.style.transform = `translateY(${Math.max(
      0,
      50 * (1 - (progress + 0.3) / (0.3 - 0.1)),
    )}vh)`;
    return;
  }
  contentRef.current.style.transform = `translateY(0)`;
  if (progress < 0.3) {
    deviceRef.current.style.opacity = '1';
    notificationImgRef.current.style.opacity = `${
      (progress - 0.2) / (0.3 - 0.2)
    }`;
    notificationImgRef.current.style.transform = `scale(${Math.min(
      1,
      0.5 + (progress - 0.2) / (0.3 - 0.2),
    )})`;
    imgRef.current.style.opacity = `0`;
    bgRef.current.style.opacity = `1`;
    return;
  }
  if (progress < 0.4) {
    deviceRef.current.style.opacity = '1';
    notificationImgRef.current.style.opacity = '1';
    notificationImgRef.current.style.transform = `none`;
    imgRef.current.style.opacity = `0`;
    bgRef.current.style.opacity = `1`;
    return;
  }
  if (progress < 0.45) {
    notificationImgRef.current.style.opacity = `${
      1 - (progress - 0.4) / (0.45 - 0.4)
    }`;
    notificationImgRef.current.style.transform = `scale(${Math.max(
      0,
      1 - (progress - 0.4) / (0.45 - 0.4) / 2,
    )})`;
    imgRef.current.style.opacity = `0`;
    bgRef.current.style.opacity = `${1 - (progress - 0.4) / (0.45 - 0.4)}`;
    deviceRef.current.style.opacity = `${
      0.2 + 1 - (progress - 0.4) / (0.45 - 0.4)
    }`;
    return;
  }
  bgRef.current.style.opacity = '0';
  notificationImgRef.current.style.opacity = `0`;
  imgRef.current.style.opacity = `${(progress - 0.45) / (0.6 - 0.45)}`;
  deviceRef.current.style.opacity = `${0.2 + (progress - 0.45) * (0.6 - 0.45)}`;
};
